import { put } from 'redux-saga/effects';
import { resetMediaSecretKeyCommunication } from '../../../effects/organization';

export default function* resetSetSecretKeyCommunication({ payload }) {
  yield put(resetMediaSecretKeyCommunication({ appId: payload.appId }));
}
